export function AZIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 4a1 1 0 01.962.725l4 14a1 1 0 11-1.923.55l-.938-3.28A1 1 0 019 16H5a1 1 0 01-.101-.005l-.937 3.28a1 1 0 11-1.924-.55l4-14A1 1 0 017 4zM5.469 14H8.53L7 8.64 5.469 14zM14 5a1 1 0 011-1h6a1 1 0 01.92 1.394L16.516 18H21a1 1 0 110 2h-6a1 1 0 01-.92-1.394L19.484 6H15a1 1 0 01-1-1zm-2 7a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
